<template>
	<div class="fuel container-fluid py-2">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="hasPageChild==0">
			<div class="col-md-12 pl-0">
				
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'

export default{
	extends: Fuel,
	components:{
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		Footer            
	},
	data() {
		return {
            value: 0,
		}
	},
	watch: {

	}, 
	computed: {

	},

    mounted() {

    },
    methods:{

	}
}
</script>